import { Box, Chip, ToggleButton, Typography, useTheme } from '@mui/material'
import React from 'react'
import { font } from '../../../styles/font';

export default function OrganisationDashboardCard({ item, showDescription }) {
  const theme = useTheme();

  return (
    <Box className="flex flex-col  gap-4 px-0 py-4 " bgcolor={theme.palette.background.paper} border={`1px solid ${theme.palette.divider}`} borderRadius={1}>

      <Box className="flex gap-4 px-4 py-0 ">
        {/* <ToggleButton value={item?.title} sx={{ background: theme.palette.highlight.light }}>
          {item?.icon}
        </ToggleButton> */}

        <Box className="flex-1 flex flex-col gap-0">
          <Typography fontWeight={"bold"} >{item?.title}</Typography>
          <Typography color="textPrimary" fontSize={font.size.fs_3} fontWeight={"bold"} >{item?.value}</Typography>
        </Box>



        {/* <ToggleButton value={item?.title} sx={{ background: theme.palette.highlight.light }}> */}
        {item?.icon}
        {/* </ToggleButton> */}
      </Box>

      {showDescription && (
        <Box className="flex flex-col gap-0 px-4 py-0">
          <Typography color="success">{item?.description}</Typography>
        </Box>
      )}


      {false && <Box className="flex flex-col gap-0 px-4 py-0">
        <Typography >{item?.subTitle}</Typography>
        <Typography color="secondary">{item?.subTitleDescription}</Typography>
      </Box>}

    </Box>
  )
}

